import React, { useEffect, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
// Components
import Answer from "../AcsiPpi/AcsiAnswer";
import Question from "../AcsiPpi/AcsiQuestions";
import ScoringParameters from "../AcsiPpi/AcsiScoringParameters";

const PsychologicalACSISettings = () => {

    const { getSubSubMenus } = usePermissions();
    const subSubMenus = getSubSubMenus("Psychological ACSI Setting");
    const [activeTab, setActiveTab] = useState("");

    const componentMap: Record<string, React.ReactNode> = {
        "Answer": <Answer />,
        "Question": <Question />,
        "Scoring Parameters": <ScoringParameters />,
    };

    
    const tabData = subSubMenus
        .filter((menu: any) =>
            menu.permissions
                ?.split(",")
                .map((permission: string) => permission.trim())
                .includes("view")
        )
        .map((menu: any) => {

            const title = menu.title.trim();

            return {
                name: title,
                route: menu.route,
                icon: <i className="fas fa-cog" />,
                content: componentMap[title] || (
                    <div>
                        No component configured for {title}
                    </div>
                ),
            };
        });

    useEffect(() => {
        if (tabData.length > 0) {
            setActiveTab((currentTab) => {
                const stillExists = tabData.some(
                    (tab) => tab.name === currentTab
                );
                return stillExists
                    ? currentTab
                    : tabData[0].name;
            });

        } else {
            setActiveTab("");
        }
    }, [subSubMenus]);

    return (
        <div className="content container" style={{ maxWidth: "1500px" }}>
            <div className="sortby-section">
                <div className="sorting-info">
                    <div className="row">
                        {/* LEFT SIDE - TABS */}
                        <div className="col-lg-2">
                            <ul className="list-group">
                                {tabData.map((tab, i) => (
                                    <li
                                        key={i}
                                        className={`list-group-item ${activeTab === tab.name ? "active" : ""}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setActiveTab(tab.name)}
                                    >
                                        {tab.name?.replaceAll("_", " ").toUpperCase()}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* RIGHT SIDE - CONTENT */}
                        <div className="col-lg-10">
                            {tabData.filter((tab) => tab.name === activeTab).map((tab, i) => (
                                <div key={i}>
                                    {tab.content}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PsychologicalACSISettings;